import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { AriaSort } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { TooltipModule } from 'src/app/shared/tooltip/tooltip.module';
import { images } from 'src/images';

@Component({
  selector: '[app-sortable-column-header]',
  templateUrl: './sortable-column-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipModule],
  host: {
    '[attr.aria-sort]': 'ariaSort()',
  },
})
export class SortableColumnHeaderComponent {
  readonly icon = input.required<string>();
  readonly labelKey = input.required<string>();
  readonly ariaSort = input.required<AriaSort>();
  readonly showLabel = input(false);
  readonly sort = output<void>();

  readonly isActive = computed(() => this.ariaSort() !== AriaSort.NONE);
  readonly isAscending = computed(() => this.ariaSort() === AriaSort.ASCENDING);

  readonly images = images;

  constructor(public literalService: LiteralService) {}
}
